/**
 * Enhanced Cart Page — AJAX Quantity & Remove
 * Uses Shopify Cart API (/cart/change.js) via jQuery
 * Self-contained: includes its own money formatting (no dependency on ajaxify.js)
 */
(function($) {
  'use strict';

  /* ───── Money Formatting (self-contained) ─────────────────────────────── */
  // window.moneyFormat is set by theme.liquid in the <body>, so we read it
  // lazily at call-time (not at script-load time) to ensure it's available.
  function getMoneyFormat() {
    return window.moneyFormat || '{{amount}}';
  }

  function formatMoney(cents, format) {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }
    cents = parseInt(cents, 10) || 0;

    var value = '';
    var formatStr = format || getMoneyFormat();
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var match = formatStr.match(placeholderRegex);

    if (!match) return cents;

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = (typeof precision === 'undefined') ? 2 : precision;
      thousands = thousands || ',';
      decimal = decimal || '.';

      if (isNaN(number) || number == null) return '0';

      number = (number / 100.0).toFixed(precision);
      var parts = number.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var pennies = parts[1] ? (decimal + parts[1]) : '';

      return dollars + pennies;
    }

    switch (match[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
      case 'amount_with_apostrophe_separator':
        value = formatWithDelimiters(cents, 2, "'", '.');
        break;
      default:
        value = formatWithDelimiters(cents, 2);
    }

    return formatStr.replace(placeholderRegex, value);
  }

  /* ───── Enhanced Cart Controller ──────────────────────────────────────── */
  var EnhancedCart = {
    config: {
      debounceDelay: 350,
      animationDuration: 400
    },

    debounceTimers: {},

    init: function() {
      this.bindEvents();
    },

    /* ───── Event Binding ───────────────────────────────────────────────── */
    bindEvents: function() {
      var self = this;

      // Increment
      $(document).on('click', '.js-cart-qty-plus', function(e) {
        e.preventDefault();
        var $item = $(this).closest('.enhanced-cart__item');
        var $input = $item.find('.enhanced-cart__qty-input');
        var current = parseInt($input.val(), 10) || 1;
        var newQty = current + 1;
        $input.val(newQty);
        self.debouncedUpdate($item);
      });

      // Decrement
      $(document).on('click', '.js-cart-qty-minus', function(e) {
        e.preventDefault();
        var $item = $(this).closest('.enhanced-cart__item');
        var $input = $item.find('.enhanced-cart__qty-input');
        var current = parseInt($input.val(), 10) || 1;
        if (current <= 1) return; // Min is 1; use Remove to delete
        var newQty = current - 1;
        $input.val(newQty);
        self.debouncedUpdate($item);
      });

      // Direct input change
      $(document).on('change', '.enhanced-cart__qty-input', function() {
        var $item = $(this).closest('.enhanced-cart__item');
        var val = parseInt($(this).val(), 10);
        if (isNaN(val) || val < 1) {
          $(this).val(1);
        }
        self.debouncedUpdate($item);
      });

      // Remove
      $(document).on('click', '.js-cart-remove', function(e) {
        e.preventDefault();
        var $item = $(this).closest('.enhanced-cart__item');
        var line = parseInt($item.attr('data-line'), 10);
        self.removeItem($item, line);
      });

      // Terms & Conditions gate for checkout
      $(document).on('click', '.js-cart-checkout', function(e) {
        var $agree = $('#enhanced-cart-agree');
        if ($agree.length && !$agree.is(':checked')) {
          e.preventDefault();
          // Subtle shake animation on the terms row
          var $terms = $('.enhanced-cart__terms');
          $terms.css('animation', 'none');
          setTimeout(function() {
            $terms.css('animation', 'ecart-shake 0.4s ease');
          }, 10);
          alert("You must agree with the terms and conditions of sales to check out.");
          return false;
        }
      });
    },

    /* ───── Debounced Update ─────────────────────────────────────────────── */
    debouncedUpdate: function($item) {
      var self = this;
      var line = parseInt($item.attr('data-line'), 10);
      var lineKey = 'line_' + line;

      if (self.debounceTimers[lineKey]) {
        clearTimeout(self.debounceTimers[lineKey]);
      }

      self.debounceTimers[lineKey] = setTimeout(function() {
        var qty = parseInt($item.find('.enhanced-cart__qty-input').val(), 10) || 1;
        self.updateItem($item, line, qty);
      }, self.config.debounceDelay);
    },

    /* ───── AJAX Update Item ────────────────────────────────────────────── */
    updateItem: function($item, line, quantity) {
      var self = this;

      // Show loading state
      $item.addClass('is-updating');

      $.ajax({
        type: 'POST',
        url: '/cart/change.js',
        data: {
          line: line,
          quantity: quantity
        },
        dataType: 'json',
        success: function(cart) {
          try {
            // Item was removed (qty set to 0) or no longer exists at this line
            if (quantity === 0 || !cart.items[line - 1]) {
              self.handleRemoval($item, cart);
              return;
            }

            var updatedItem = cart.items[line - 1];

            // Update line total
            $item.find('.js-line-total').html(formatMoney(updatedItem.line_price));

            // Update unit price (in case of price breaks)
            $item.find('.enhanced-cart__unit-price').html(formatMoney(updatedItem.price));

            // Update quantity (server might have capped it due to inventory)
            $item.find('.enhanced-cart__qty-input').val(updatedItem.quantity);

            // Update cart summary
            self.updateSummary(cart);

            // Update header cart
            self.updateHeaderCart(cart);
          } catch (err) {
            // If anything fails in rendering, log it but still remove loading
            if (window.console) console.error('Cart update render error:', err);
          }

          // Always remove loading state
          $item.removeClass('is-updating');
        },
        error: function(xhr) {
          // Remove loading state
          $item.removeClass('is-updating');

          // Try to show a meaningful error
          try {
            var data = JSON.parse(xhr.responseText);
            if (data && data.description) {
              self.showToast(data.description);
            } else {
              self.showToast('Could not update quantity. Please try again.');
            }
          } catch (e) {
            self.showToast('Could not update quantity. Please try again.');
          }
        }
      });
    },

    /* ───── Remove Item ─────────────────────────────────────────────────── */
    removeItem: function($item, line) {
      var self = this;

      $item.addClass('is-updating');

      $.ajax({
        type: 'POST',
        url: '/cart/change.js',
        data: {
          line: line,
          quantity: 0
        },
        dataType: 'json',
        success: function(cart) {
          self.handleRemoval($item, cart);
        },
        error: function() {
          $item.removeClass('is-updating');
          self.showToast('Could not remove item. Please try again.');
        }
      });
    },

    /* ───── Handle Item Removal Animation ────────────────────────────────── */
    handleRemoval: function($item, cart) {
      var self = this;

      // Animate out
      $item.removeClass('is-updating').addClass('is-removing');

      setTimeout(function() {
        $item.remove();

        // Re-index remaining items' data-line attributes
        $('.enhanced-cart__item').each(function(index) {
          $(this).attr('data-line', index + 1);
        });

        // Update summary
        self.updateSummary(cart);

        // Update header
        self.updateHeaderCart(cart);

        // If cart is empty, show empty state
        if (cart.item_count === 0) {
          self.showEmptyState();
        }
      }, self.config.animationDuration);
    },

    /* ───── Update Summary Section ───────────────────────────────────────── */
    updateSummary: function(cart) {
      // Update subtotal
      $('.js-cart-subtotal').html(formatMoney(cart.total_price));

      // Update discount if present
      if (cart.total_discount > 0) {
        $('.js-cart-discount-amount').html('-' + formatMoney(cart.total_discount));
        $('.js-cart-discount-row').show();
      } else {
        $('.js-cart-discount-row').hide();
      }
    },

    /* ───── Update Header Cart (mini-cart in header) ──────────────────── */
    updateHeaderCart: function(cart) {
      // Update count badge
      $('.txt_number').html(cart.item_count);

      // Update total price in header
      var formattedTotal = formatMoney(cart.total_price);
      $('#cart .total-price, #cart-total .total-price').html(formattedTotal);

      // Update subtotal in header dropdown
      $('#cart-subtotal').html(formattedTotal);
    },

    /* ───── Show Empty Cart State ────────────────────────────────────────── */
    showEmptyState: function() {
      var $container = $('.enhanced-cart__content');
      $container.fadeOut(300, function() {
        $container.replaceWith(
          '<div class="enhanced-cart__empty">' +
            '<div class="enhanced-cart__empty-icon"><i class="fa fa-shopping-cart"></i></div>' +
            '<h2>Your cart is currently empty.</h2>' +
            '<p>Continue browsing <a href="/collections/all">here</a>.</p>' +
            '<a href="/collections/all" class="enhanced-cart__empty-btn">Continue Shopping</a>' +
          '</div>'
        );
        $('.enhanced-cart__empty').hide().fadeIn(400);
      });
    },

    /* ───── Toast Notification ───────────────────────────────────────────── */
    showToast: function(msg) {
      if (typeof toastr !== 'undefined') {
        toastr.error(msg);
      } else {
        alert(msg);
      }
    }
  };

  // Initialize on DOM ready
  $(function() {
    EnhancedCart.init();
  });

})(jQuery);
